import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'addEntriesToList-panel',
    templateUrl: './addEntriesToList-panel.component.html',
    styleUrls: ['./addEntriesToList-panel.component.css'],
    standalone: false
})
export class AddEntriesToListComponent implements OnInit {
    public newKeyword: string = '';

    @Input()
    public keywordPanel: boolean;

    @Input()
    public editable: boolean;

    /**
     * Keywords ist ein Array, welches entweder Features oder Schlagworte enthält und einem Produkt/PTG/Zertifikat hinzufügt
     */
    @Input()
    public keywords: string[] = [];

    @Output()
    public keywordsChange = new EventEmitter();

    constructor(private dialogService: DialogService) {}

    ngOnInit() {
        if (!this.keywords) {
            this.keywords = [];
        }
    }

    addKeyword() {
        if (!this.newKeyword) return;

        const wordCount = this.newKeyword.trim().split(/\s+/).length;
        if (wordCount > 2) {
            this.dialogService.openDialog(
                'Hinweis zur Eingabe',
                'Bitte geben Sie nur bis zu 2 Wörter ein.'
            );
            return;
        }

        if (this.keywords.length >= 10) {
            this.dialogService.openDialog(
                'Maximale Anzahl erreicht',
                'Ein Produkt kann nur 10 Stärken enthalten. Um eine weitere hinzuzufügen, entfernen Sie bitte eine bereits eingetragene Stärke.'
            );
            return;
        }

        this.keywords.push(this.newKeyword);
        this.newKeyword = '';
        this.keywordsChange.emit(this.keywords);
    }

    removeKeyword(keyword) {
        const index = this.keywords.indexOf(keyword, 0);
        if (index > -1) {
            this.keywords.splice(index, 1);
        }
    }

    limitToTwoWords() {
        const words = this.newKeyword.trim().split(/\s+/);
        if (words.length > 2) {
            this.newKeyword = words.slice(0, 2).join(' ');
        }
    }
}
